import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { Coupling } from 'models/Connections';
import { CouplingService } from 'services';
import { ErrorService } from 'services/error-service';

@autoinject
export class CouplingList {
  protected newButtonText = '';
  protected couplings: Array<Coupling>;
  protected activeTableRow: number;
  protected loaded = false;

  constructor(
    private couplingsService: CouplingService,
    private errorService: ErrorService,
    private router: Router,
    private eventAggregator: EventAggregator,
    private i18n: I18N
  ) {
    this.newButtonText = this.i18n.tr('general.createNew', {
      replace: {
        value: this.i18n.tr('general.coupling').toLowerCase(),
      },
    });
  }

  protected activate(params: { Id: number }) {
    this.activeTableRow = params?.Id || 0;
  }

  protected attached() {
    this.eventAggregator.subscribe('coupling-list-reset', () => {
      this.activeTableRow = null;
      void this.getCouplings();
    });
    void this.getCouplings();
  }

  private async getCouplings() {
    try {
      this.couplings = await this.couplingsService.getAll('?$orderby=Title');
      this.loaded = true;
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  protected gotoDetailView(id: number) {
    this.activeTableRow = id;
    this.router.navigateToRoute('coupling-detail', { Id: id });
  }
}
